import type { ValueOf } from './helper';
import type { File, PageRef } from './fsReference';

export const LinkTarget = {
  self: '_self',
  blank: '_blank',
} as const;

export const LinkType = {
  internal: 'internal',
  external: 'external',
} as const;

export type LinkTypeIdentifier = {
  label: string;
  identifier: ValueOf<typeof LinkType>;
};

export const LinkVariant = {
  primary: 'primary',
  secondary: 'secondary',
  ghost: 'ghost',
  link: 'link',
  linkStatic: 'linkStatic',
  none: 'none',
} as const;

export type Link = {
  _id?: string;
  icon?: string;
  image?: string;
  media?: string;
  id?: string;
  label?: string;
  target?: ValueOf<typeof LinkTarget>;
  newWindow?: boolean;
  title?: string;
  url?: string;
  action?: () => void;
  position?: number;
  variant?: ValueOf<typeof LinkVariant>;
  type?: ValueOf<typeof LinkType>;
  noFollow?: boolean;
  src?: string;
};

export interface NavigationNode extends Link {
  children?: NavigationNode[];
  teaserId?: string;
  teaserUrl?: string;
  hideInNavigation?: boolean;
}

export type LinkBasis = {
  lt_link_text: string;
  lt_link_target?: string;
  lt_link_nofollow?: boolean;
  lt_link_variant?: ValueOf<typeof LinkVariant>;
};

export type ExternalLink = LinkBasis & {
  lt_link_url: string;
  lt_link_type: typeof LinkType.external;
};

export type InternalLink = LinkBasis & {
  lt_link_ref?: PageRef | File;
  lt_link_type: typeof LinkType.internal;
};
